export default {
  flowError: state => state.flowError,
  flowCompanyColor: state => state.flowCompanyColor
}
